export default function chunkReadMores(el) {
  if (!el) return

  import(/* webpackChunkName: "read-more" */ "./read-more").then(({ default: readMore }) =>
    readMore(el),
  )
}
